import React from 'react';
import { TextNote } from 'page/Application/ManageProjectRegistration/component/styled';

const FormNote = ({ text }) => {
  return <TextNote>{text}</TextNote>;
};

export default FormNote;
